import React, { createContext, useContext, useState } from "react"
import { Backdrop } from "@mui/material"
import ExfluencyLoader from "src/components/ExfluencyLoader"

interface GlobalLoaderContextValue {
  showLoader: () => void
  hideLoader: () => void
}

const initialValue: GlobalLoaderContextValue = {
  showLoader: () => {
    console.warn("GlobalLoaderProvider not initialized")
  },
  hideLoader: () => {
    console.warn("GlobalLoaderProvider not initialized")
  }
}

export const GlobalLoaderContext = createContext<GlobalLoaderContextValue>(initialValue)

interface Props {
  children: React.ReactNode
}

export const GlobalLoaderProvider = ({ children }: Props) => {
  const [open, setOpen] = useState(false)

  const showLoader = () => {
    setOpen(true)
  }

  const hideLoader = () => {
    setOpen(false)
  }

  return (
    <GlobalLoaderContext.Provider value={{ showLoader, hideLoader }}>
      {children}
      <Backdrop sx={{ zIndex: (theme) => theme.zIndex.modal + 1, m: 0 }} open={open}>
        <ExfluencyLoader />
      </Backdrop>
    </GlobalLoaderContext.Provider>
  )
}

export const useGlobalLoader = () => {
  const context = useContext(GlobalLoaderContext)
  if (!context) {
    throw new Error("useGlobalLoader must be used within a GlobalLoaderProvider")
  }
  return context
} 